
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.5 15.19V9.73L20 1.83 1.5 9.8v5.47zM37.86 31.36v6.73l-35.73.08v-6.73zM33.65 31.09l-.04-15.31M6.4 15.84l.04 15.31M15.47 15.83l.04 15M24.55 15.81l.03 15.01","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    